var o="aptos:connect";export{o as a};
//# sourceMappingURL=chunk-OYMA2PWW.mjs.map